import { Text, TextButton } from '@oneaudi/unified-web-components';
import { StyledAvpErrorWrapper } from '~/app/compositions/content/gallery/avp/styles/avp-error-style';
import { useI18n } from '~/app/i18n/i18n';
import { DATA_TEST_ID } from '~/test/data-test-id';

export const AvpError = ({ onBackAfterError }: { onBackAfterError: () => void }) => {
	const { i18n } = useI18n();

	return (
		<StyledAvpErrorWrapper>
			<Text tag="p" variant={{ type: 'copy', order: '1', style: 'normal' }}>
				{i18n('ngc.avp.galleryErrorText')}
			</Text>
			<TextButton
				variant="secondary"
				size="sm"
				onClick={onBackAfterError}
				aria-label={i18n('ngc.actions.backFromError')}
				data-testid={DATA_TEST_ID.GALLERY_ERROR_3D_BUTTON_BACK}>
				{i18n('ngc.avp.galleryControlBackError')}
			</TextButton>
		</StyledAvpErrorWrapper>
	);
};
